import jQuery from 'jquery';
const eventHandlers = [];
let previousBreakpoint = null;
function getBreakpoints() {
    return window.getComputedStyle(document.documentElement, ':before').getPropertyValue('content').replace(/"/g, '').split(',');
}
function getBreakpoint() {
    return window.getComputedStyle(document.documentElement, ':after').getPropertyValue('content').replace(/"/g, '');
}
jQuery(window).on('resize', (event) => {
    const currentBreakpoint = getBreakpoint();
    if (previousBreakpoint !== currentBreakpoint) {
        eventHandlers.forEach((eventHandler) => {
            eventHandler(event, {
                previous: previousBreakpoint,
                current: currentBreakpoint,
            });
        });
    }
    previousBreakpoint = currentBreakpoint;
});
function isLessThanBreakpoint(breakpoint, inclusive = false) {
    const breakpoints = getBreakpoints();
    const currentBreakpoint = getBreakpoint();
    const comparison = breakpoints.indexOf(currentBreakpoint) - breakpoints.indexOf(breakpoint);
    return inclusive ? comparison <= 0 : comparison < 0;
}
function isGreaterThanBreakpoint(breakpoint, inclusive = false) {
    const breakpoints = getBreakpoints();
    const currentBreakpoint = getBreakpoint();
    const comparison = breakpoints.indexOf(currentBreakpoint) - breakpoints.indexOf(breakpoint);
    return inclusive ? comparison >= 0 : comparison > 0;
}
function isBreakpoint(...breakpoints) {
    const currentBreakpoint = getBreakpoint();
    return breakpoints.some((breakpoint) => breakpoint === currentBreakpoint);
}
function onBreakpointChange(eventHandler) {
    if (eventHandlers.indexOf(eventHandler) === -1) {
        eventHandlers.push(eventHandler);
    }
}
function offBreakpointChange(eventHandler) {
    const index = eventHandlers.indexOf(eventHandler);
    if (index !== -1) {
        eventHandlers.splice(index, 1);
    }
}
const Layout = {
    isLessThanBreakpoint,
    isGreaterThanBreakpoint,
    isBreakpoint,
    onBreakpointChange,
    offBreakpointChange,
};
export default Layout;
